import { generateId } from '@freelancer/datastore/testing';
import { DepositPageVars } from './deposit-page-vars.model';

export function generateDepositPageVarsObjects(): readonly DepositPageVars[] {
  return [
    {
      amount: undefined,
      back: undefined,
      bidderId: undefined,
      cartId: undefined,
      contractQuantity: undefined,
      currency: undefined,
      dataToken: undefined,
      descr: undefined,
      durationCycle: undefined,
      durationType: undefined,
      entryId: undefined,
      hiremeInitialMilestoneTracking: undefined,
      id: generateId().toString(),
      listingId: undefined,
      membershipCoupon: undefined,
      membershipRef: undefined,
      milestoneAmount: undefined,
      milestoneRequestId: undefined,
      nextAction: undefined,
      oneTimeNotify: undefined,
      orgBackUrl: undefined,
      orgTrackingToken: undefined,
      packageId: undefined,
      paymentItem: undefined,
      pid: undefined,
      priorityRef: undefined,
      redirected: undefined,
      refAction: undefined,
      returnToProject: undefined,
      toCorporateOnboarding: undefined,
      toFinancialDashboard: undefined,
      uid: undefined,
      upgradeOptions: undefined,
      username: undefined,
      verifiedPayment: undefined,
      generatedVars: {
        trackingToken: '',
        backUrl: {
          encoded: '',
          raw: '/dashboard',
        },
        banner: {
          body: '',
          cancelBtnText: '',
          cancelUrl: '',
        },
      },
    },
  ];
}
